//Libs
import { Listbox, Transition } from "@headlessui/react";
import { ChevronDownIcon, CheckIcon } from "@heroicons/react/24/solid";
import { Dispatch, Fragment } from "react";
//Local

interface Props {
  currentTaskType: string;
  setCurrentTaskType: Dispatch<React.SetStateAction<string>>;
  setSelectedTaskType: (taskType: string | null) => void;
  tasks: string[] | undefined;
}

export default function TaskTypeDropdown({
  currentTaskType,
  setCurrentTaskType,
  setSelectedTaskType,
  tasks,
}: Props) {
  return (
    <Listbox
      value={currentTaskType}
      onChange={(event) => {
        // 'event' contains the taskType string
        setCurrentTaskType(event);
        setSelectedTaskType(event);
      }}
    >
      <div className="relative z-50 mt-1">
        <Listbox.Button
          id="selectTaskType"
          className="relative h-10 w-full cursor-pointer rounded-md border border-primary bg-white py-2 pl-3 pr-10 text-left outline-none focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-primaryLight"
        >
          <span className="block truncate">{currentTaskType}</span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronDownIcon
              className="h-5 w-5 text-gray-700"
              aria-hidden="true"
            />
          </span>
        </Listbox.Button>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="absolute isolate z-50 mt-1 max-h-32 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
            {!tasks ? (
              <Listbox.Option
                value="select work type first"
                className="relative cursor-default select-none py-2 pl-10 pr-4 text-gray-700"
                disabled={true}
              >
                Select a work type first
              </Listbox.Option>
            ) : (
              tasks.map((taskType) => (
                <Listbox.Option
                  key={taskType}
                  className={({ active, selected }) =>
                    `relative z-10 cursor-default select-none py-2 pl-10 pr-4 ${
                      active || selected
                        ? "bg-primaryOpacity90 text-primary"
                        : "text-gray-700"
                    }`
                  }
                  value={taskType}
                >
                  {({ selected }) => (
                    <>
                      <span
                        className={`block truncate ${
                          selected ? "font-medium" : "font-normal"
                        }`}
                      >
                        {taskType}
                      </span>
                      {selected ? (
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-primary">
                          <CheckIcon className="h-5 w-5" aria-hidden="true" />
                        </span>
                      ) : null}
                    </>
                  )}
                </Listbox.Option>
              ))
            )}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
}
